import { BlockHeader, BlockHeaderContent } from '@/cms/BlockHeaderContentDC';
import { BlockWrapper } from '@/cms/BlockWrapperDC';
import { BlockComponentModel } from '@/cms/types/blok-component';
import { RecommendationCardProps } from '@/decodo/blocks/RecommendationCards/RecommendationCard';
import { RecommendationCards } from '@/decodo/blocks/RecommendationCards/RecommendationCards';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/decodo/components/atoms/Image/ImageStrapi';
import LinkButtonStrapi, {
  LinkButtonStrapiProps,
} from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { FeatureListStrapiProps } from '@/decodo/features/FeatureListStrapi/FeatureListStrapiDC';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

interface RecommendationCardsStrapiProps {
  header?: BlockHeader;
  cards: {
    icon?: ImageStrapiProps;
    title: string;
    subtitle?: string;
    features: FeatureListStrapiProps;
    description: RichTextFieldStrapiProps;
    cta: LinkButtonStrapiProps;
    isRecommended?: boolean;
  }[];
}

export const RecommendationCardsStrapi = ({
  block,
  ...rest
}: BlockComponentModel<RecommendationCardsStrapiProps>) => {
  const { header, cards } = block;

  return (
    <BlockWrapper
      {...rest}
      data-tracker-section={SECTION_NAMES.RECOMMENDATION_CARDS}
    >
      <div data-tracker-section='recommendation-cards'>
        <BlockHeaderContent {...header}>
          <RecommendationCards cards={transformCards(cards)} />
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
};

const transformCards = (cards: RecommendationCardsStrapiProps['cards']) => {
  return cards.map(
    (card) =>
      ({
        title: card.title,
        subtitle: card.subtitle,
        features: {
          icon: !!card.features.icon && (
            <ImageStrapi
              block={card.features.icon}
              inner={{
                classNames: { container: 'h-6 flex items-center' },
              }}
            />
          ),
          features: card.features.features.map((feature) => feature.name),
        },
        icon: !!card.icon && (
          <ImageStrapi
            inner={{ classNames: { image: 'w-9' } }}
            block={card.icon}
          />
        ),
        description: !!card.description && (
          <RichTextFieldStrapi block={card.description} />
        ),
        cta: !!card.cta && (
          <LinkButtonStrapi
            block={card.cta}
            inner={{
              fullwidth: true,
            }}
          />
        ),
        isRecommended: card.isRecommended,
      } satisfies RecommendationCardProps)
  );
};
